import * as dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

/**
 * 日期时间格式化
 *
 * @export
 * @param {Date | number | string} [datetime=new Date()] 日期时间
 * @param {string} [format="YYYY-MM-DD HH:mm:ss"] 格式化模板
 * @return {string} 格式化后的日期时间
 */
export function datetimeFormat(
  datetime = new Date(),
  format = "YYYY-MM-DD HH:mm:ss"
) {
  if (typeof datetime === "number" && datetime.toString().length === 10) {
    datetime *= 1000;
  }
  return dayjs(datetime).format(format);
}

/**
 * 毫秒数格式化为日期时间
 *
 * @export
 * @param {number} milliseconds 毫秒数
 * @param {string} [format="mm′ss″"] 格式化模板
 * @returns {string}
 */
export function durationFormat(milliseconds, format = "mm′ss″") {
  if (isNaN(milliseconds)) {
    return milliseconds;
  }
  return dayjs.duration(Number(milliseconds)).format(format);
}

// 时间戳转为10位的
export function to10(timestamp) {
  if (String(timestamp) === "") {
    return "";
  }
  if (String(timestamp).length !== 13) {
    throw "请传入13位时间戳";
  }
  return String(timestamp).substr(0, 10);
}

/**
 * 百分比
 *
 * @export
 * @param {number} val 数值
 * @param {number} [precision=2] 精度（小数点后几位）
 * @returns {string}
 *
 */
export function percentFormat(val, n = 2) {
  val = val * 100;
  n = n ? parseInt(n) : 0;
  if (n <= 0) {
    return Math.round(val);
  }
  val = Math.round(val * Math.pow(10, n)) / Math.pow(10, n); //四舍五入
  val = Number(val).toFixed(n); //补足位数
  return val;
}

/**
 * 数字格式化，三位逗号分割
 *
 * @export
 * @param {number} num 数值
 * @param {number} [precision=2] 精度（小数点后几位）
 * @returns {string}
 *
 */
export function numberFormat(num, precision = 2) {
  num = Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
  const str = num.toString();
  const reg =
    str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,");
}

/**
 * axios下载文件
 * @param {AxiosResponse} response axios的response
 * @param {string} [filename] 文件名称
 * @param {string} [fileType] 文件类型
 */
export function downloadFile(response, filename, fileType) {
  let blob = null;
  if (response.config.responseType === "arraybuffer") {
    blob = new Blob([response.data], {
      type: fileType || response?.headers?.["content-type"],
    });
  } else if (response.config.responseType === "blob") {
    blob = response.data;
  } else {
    throw Error("下载文件的responseType必须为arraybuffer或blob");
  }
  const href = window.URL.createObjectURL(blob);
  const downloadElement = document.createElement("a");
  downloadElement.href = href;
  downloadElement.download =
    filename ||
    decodeURIComponent(
      response.headers["content-disposition"]?.split("filename=")?.[1] ?? ""
    );
  document.body.appendChild(downloadElement);
  downloadElement.click();
  document.body.removeChild(downloadElement);
  window.URL.revokeObjectURL(href);
}
